module.exports = __webpack_public_path__ + "static/media/energy-icon.d1cd83fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/energy-icon.svg
// module id = 572
// module chunks = 0